import { PublicLayout } from '../components/Layout/PublicLayout'
import { useBrandCode } from '@jotta/ui/useBrandTheme'
import { useGetConfigSuspense } from '@jotta/grpc-connect-client/config'
import { Redirect } from '@jotta/ui/Redirect'
import { I18nProvider, isLocale, useLocale } from '@jotta/i18n'
import { useParams } from 'react-router-dom'
import { TermsSwitch } from '../terms/TermsSwitch'
import { ErrorPageNotFound } from '@jotta/ui/ErrorPageNotFound'

function ConfigRedirect() {
  const { data: getConfigResponse } = useGetConfigSuspense()
  const brandingInfo = getConfigResponse?.brandingInfo
  const termsLink = brandingInfo?.termsLink
  return termsLink ? <Redirect to={termsLink} /> : <ErrorPageNotFound />
}

export function TermsRoute() {
  const { fileName } = useParams()
  const brandCode = useBrandCode()
  const locale = useLocale()
  const localeParameter = fileName?.replace('.html', '')
  const overrideLocale = isLocale(localeParameter) ? localeParameter : locale
  return (
    <I18nProvider overrideLocale={overrideLocale}>
      <PublicLayout section="terms" className="prose mx-auto max-w-6xl">
        <TermsSwitch
          brand={brandCode}
          locale={locale}
          Fallback={ConfigRedirect}
        />
      </PublicLayout>
    </I18nProvider>
  )
}
